module.exports = __webpack_public_path__ + "img/resources.057a2063.webp";